<template>
    <el-dialog
        class="add"
        :visible.sync="createExternalVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Create External Link"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form ref="addForm" :model="addForm" :rules="rules" @keydown.enter.native.prevent>
                <el-row style="height:100px">
                    <el-col :span="24">
                        <el-form-item
                            label="Name"
                            prop="name"
                            size="small"
                        >
                            <el-input
                                clearable
                                size="small"
                                v-model="addForm.name"
                                placeholder="Please input"
                            ></el-input>
                        </el-form-item>
                    </el-col>  
                    
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                type="primary"
                @click="save"
                :loading="loading"
                >Save</el-button
            >
            <el-button size="small" @click="createExternalVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { mapActions } from "vuex";
export default {
    data() {
        return {
            addForm: {
                name: "",
            },
            expressList:{},
            rules: {
                name: [
                    {
                        required: true,
                        message: "Please input name",
                    },
                ],
            },
        };
    },
    methods: {
        save() {
            this.$refs["addForm"].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    cmofferApi
                        .createExternalLink(
                            {
                                ...this.addForm,
                            },
                            "post"
                        )
                        .then((res) => {
                            this.loading = false;
                            this.closeDialog();
                            this.$message.success(
                                this.$i18n.locale == "zh" ? "成功" : "Success"
                            );
                            this.$parent.$parent[this.funcName] &&
                                this.$parent.$parent[this.funcName]();
                                this.closeDialog();
                        });
                }
            });
            
        },
        closeDialog() {
            this.addForm = {
                name: "",
            };
            this.$refs["addForm"].clearValidate();
            this.$refs["addForm"].resetFields();
            this.$emit("update:createExternalVisible", false);
        },

    },
    props: {
        createExternalVisible: Boolean,
        funcName: String
    },
    watch: {
        createExternalVisible(val) {
        },
    },
};
</script>

<style lang="scss" scoped>
.add {
    ::v-deep .container {
        .el-input {
            & + .el-input {
                margin-top: 10px;
            }
        }
        .el-select {
            width: 100%;
        }
        .el-form-item--small {
            margin-bottom: 5px !important;
        }
        .el-checkbox__label {
            font-size: 12px;
        }
        .el-radio-group {
            width: 100%;
        }
    }
}
</style>
